import { useTranslation } from 'react-i18next';
import { func, object } from 'prop-types';
import { useForm } from 'react-hook-form';
import { getError } from 'components/helpers';
import { Field } from 'components/molecules';

const CountryForm = ({ onSubmit, country }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: country || {}
  });

  const validators = {
    name: {
      required: 'required'
    },
    emailDomain: {
      required: 'required'
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} id="countryForm">
      <input type="hidden" />
      <Field
        {...register('name', validators.name)}
        type="text"
        label={`${t('general:name')} *`}
        placeholder={t('general:name')}
        error={t(getError(['name', 'message'], errors))}
      />
    </form>
  );
};

CountryForm.propTypes = {
  onSubmit: func.isRequired,
  country: object
};

CountryForm.defaultProps = {
  country: null
};

export default CountryForm;
